import {Component, inject, isDevMode, signal} from '@angular/core';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, RouterOutlet} from '@angular/router';
import {AppHeader} from './shared/components/app-header/app-header';
import {AppFooter} from './shared/components/app-footer/app-footer';
import {AppBaseComponent} from './shared/components/app-base-component/app-base-component';
import {ErrorDialog} from './shared/components/error-dialog/error-dialog';
import {Toast} from 'primeng/toast';
import {CompleteProfileDialog} from './dialogs/complete-profile-dialog/complete-profile-dialog';
import {StorageService} from './shared/services/storage-service';
import {ConfirmDialog} from 'primeng/confirmdialog';
import {LOGIN, LOGIN_REQUIRED, USER_UPDATED} from './event-disctionary';
import {LightboxConfig} from 'ngx-lightbox';

declare const google: any;

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppHeader, AppFooter, Toast, ConfirmDialog],
  templateUrl: './app.html',
  styleUrl: './app.css',
  providers: [
    LightboxConfig
  ]
})
export class App extends AppBaseComponent {
  protected readonly title = signal('laavan-phere-website');
  showChunkLoader = signal(false);

  constructor(private _lightboxConfig: LightboxConfig) {
    super();
    // override default config
    _lightboxConfig.fadeDuration = 1;

    this.eventBus.on(LOGIN).subscribe(() => this.showCompleteProfile());
    this.eventBus.on(USER_UPDATED).subscribe(() => this.updateUserInfo());
    this.eventBus.on(LOGIN_REQUIRED).subscribe(() => this.showError());
    this.eventBus.on('complete_profile').subscribe(() => this.showCompleteProfileDialog());
    // this.socialAuthService.authState.subscribe((user) => {
    //   this.http.post('user/check-social-login', {...user, 'authToken': user.idToken}).subscribe((res: any) => {
    //     if (!res.user.profile_completed) this.showCompleteProfileDialog();
    //   })
    // });
    this.showCompleteProfile();


    this.router.events.subscribe(event => {
      if (
        event instanceof RouteConfigLoadStart
      ) {
        this.showChunkLoader.set(true);
      }

      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError ||
        event instanceof RouteConfigLoadEnd
      ) {
        this.showChunkLoader.set(false);
      }
    });
  }

  updateUserInfo() {
    this.http.get('user/check').subscribe((res: any) => {
      this.authService.saveUser(res);
    })
  }

  showCompleteProfile() {
    if (this.authService.user()?.profile_completed == false) {
      this.showCompleteProfileDialog();
    }
  }

  showError() {
    this.dialogService.open(ErrorDialog, {
      closable: true,
      header: 'Login Required',
      showHeader: false,
      modal: true,
      inputValues: {
        message: 'Action unavailable. You must be logged in to like or unlike profiles. Please sign in and try again.'
      }
    })
  }

  showCompleteProfileDialog() {
    this.dialogService.open(CompleteProfileDialog, {
      closable: false,
      unstyled: true,
      maskStyleClass: 'scroll-dialog',
      styleClass: 'w-[90%] max-w-[600px]',
      showHeader: false,
      modal: true,
    })
  }

}
